import React from 'react';

const th = 'px-2 py-2 text-left text-xs font-medium text-gray-600 uppercase tracking-wider';
const td = 'px-2 py-2 text-sm text-gray-800 border-t border-gray-100 align-top max-w-[10rem] break-words';

function statusBadge(status) {
  if (status === 'valid') {
    return (
      <span className="text-xs font-medium text-green-700 bg-green-100 px-2 py-0.5 rounded-full">
        Se actualizará
      </span>
    );
  }
  if (status === 'unchanged') {
    return <span className="text-xs text-gray-500 bg-gray-100 px-2 py-0.5 rounded-full">Sin cambios</span>;
  }
  if (status === 'empty') {
    return <span className="text-xs text-gray-500">Vacía</span>;
  }
  return <span className="text-xs font-medium text-red-700 bg-red-50 px-2 py-0.5 rounded-full">No válida</span>;
}

const PriceListPricesPreviewModal = ({ isOpen, onClose, preview, onConfirm, confirming }) => {
  if (!isOpen || !preview?.success) return null;

  const { previewRows, validCount, emptyCount, invalidCount, unchangedCount } = preview;

  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-[60] p-4"
      onClick={(e) => {
        if (e.target === e.currentTarget && !confirming) onClose();
      }}
      role="presentation"
    >
      <div
        className="bg-white rounded-lg shadow-xl max-w-5xl w-full max-h-[90vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="price-list-preview-title"
      >
        <div className="p-4 border-b border-gray-200 flex-shrink-0">
          <h3 id="price-list-preview-title" className="text-lg font-semibold text-gray-900">
            Vista previa — importación de precios
          </h3>
          <p className="text-sm text-gray-600 mt-1">
            Solo se actualizarán celdas de precio con valor nuevo distinto al del sistema.
          </p>
          <p className="text-sm mt-2">
            <span className="text-green-700 font-medium">{validCount}</span> precio(s) a actualizar
            {unchangedCount > 0 ? (
              <>
                {' · '}
                <span className="text-gray-500">{unchangedCount} fila(s) sin cambios</span>
              </>
            ) : null}
            {emptyCount > 0 ? (
              <>
                {' · '}
                <span className="text-gray-500">{emptyCount} vacías</span>
              </>
            ) : null}
            {invalidCount > 0 ? (
              <>
                {' · '}
                <span className="text-red-700 font-medium">{invalidCount} con error</span>
              </>
            ) : null}
          </p>
        </div>

        <div className="overflow-auto flex-1 p-4">
          <table className="min-w-full border border-gray-200 rounded-md overflow-hidden text-sm">
            <thead className="bg-gray-50 sticky top-0">
              <tr>
                <th className={th}>Fila</th>
                <th className={th}>ID</th>
                <th className={th}>SKU</th>
                <th className={th}>Nombre</th>
                <th className={th}>Cambios</th>
                <th className={th}>Estado</th>
                <th className={th}>Detalle</th>
              </tr>
            </thead>
            <tbody className="bg-white">
              {previewRows.map((row) => (
                <tr
                  key={row.excelRow}
                  className={
                    row.status === 'invalid'
                      ? 'bg-red-50/50'
                      : row.status === 'unchanged'
                      ? 'bg-gray-50/80'
                      : ''
                  }
                >
                  <td className={td}>{row.excelRow}</td>
                  <td className={td}>{row.cols.id ?? '—'}</td>
                  <td className={td}>{row.cols.sku ?? '—'}</td>
                  <td className={td}>{row.cols.nombre ?? '—'}</td>
                  <td className={`${td} max-w-xs`}>{row.cols.cambios ?? row.cols.precios ?? '—'}</td>
                  <td className={`${td} whitespace-nowrap`}>{statusBadge(row.status)}</td>
                  <td className={`${td} max-w-xs`}>{row.issue || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="p-4 border-t border-gray-200 flex justify-end gap-3 flex-shrink-0">
          <button
            type="button"
            onClick={onClose}
            disabled={confirming}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md disabled:opacity-50"
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={confirming || validCount === 0}
            className="px-4 py-2 text-sm font-medium text-white bg-teal-600 hover:bg-teal-700 rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {confirming ? 'Guardando…' : `Confirmar actualización (${validCount})`}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PriceListPricesPreviewModal;
